import { faAngleLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React  from 'react';
import { useSendPasswordResetEmail } from 'react-firebase-hooks/auth';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import auth from '../firebase.init';
import Loading from '../Shared/Loading';

const ResetPassword = () => {

    const { register, formState: { errors }, handleSubmit, reset } = useForm();
    const [sendPasswordResetEmail, sending ] = useSendPasswordResetEmail(auth);

    if(sending){
        return <Loading/>
    }


    const onSubmit = data => {
        sendPasswordResetEmail(data?.email);
        reset();
        toast.success('Send Email!');
    }


  

    return (
        <div className='flex items-center justify-center  md:h-[80vh] h-screen'>
            <div className="card mx-auto md:w-96 w-5/6 bg-base-100  shadow-xl">
                <div className="card-body">
                    <div className='flex items-start'>
                        <div className="tooltip" data-tip="login">
                            <button className=' font-bold '> <Link to='/mother'><FontAwesomeIcon icon={faAngleLeft} /></Link> </button>
                        </div>
                    </div>
                    <h2 className='uppercase text-center font-bold text-xl mb-4'>Reset Password</h2>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-control w-full ">
                            <input
                                type="email"
                                placeholder="Email"
                                className="input input-bordered w-full  "
                                {...register("email", {
                                    required: {
                                        value: true,
                                        message: "Email is required"
                                    },
                                    pattern: {
                                        value: /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/,
                                        message: "Provide a valid Email!"
                                    }
                                })}
                            />
                            <label className="label">
                                {errors.email?.type === 'required' && <span className="label-text-alt text-red-500">{errors.email.message}</span>}
                                {errors.email?.type === 'pattern' && <span className="label-text-alt text-red-500">{errors.email.message}</span>}
                            </label>
                        </div>
                        <button type='submit' className='btn w-full border-0 text-white bg-green-500' >Reset Password <FontAwesomeIcon className='ml-2' icon={ faArrowRight }></FontAwesomeIcon></button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;